<template>
    <v-dialog v-model="showDialog" width="380px">
        <v-card>
            <v-card-title style="background-color: #00BFA5; margin-bottom: 20px; position: relative;" class="white--text">
                Generate Ledger
                <v-btn
                    text
                    icon
                    style="position: absolute; right: 13px;"
                    @click="showDialog=false"
                >
                    <v-icon class="white--text">
                        {{ mdiClose }}
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-if="hosp && hosp.hosp_name"
                            v-model.trim="hosp.hosp_name"
                            disabled
                            dense
                            color="teal"
                            item-text="hosp_name"
                            label="Hospital or Clinic Name"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model.trim="from"
                            color="teal"
                            label="Start Date"
                            type="date"
                            dense
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model.trim="to"
                            color="teal"
                            label="End Data"
                            type="date"
                            dense
                        />
                    </v-col>
                    <v-col cols="12">
                        <div style="text-align: center;">
                            <v-btn
                                :loading="loadingGenBtn"
                                style="min-width: 0;"
                                color="teal"
                                class="white--text"
                                @click="genReport()"
                            >
                                Generate Ledger
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { moment } from '../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
export default {
    props: ['show', 'hosp'],
    data: ()=>({
        mdiClose,
        loadingGenBtn: false,
        notif: {
            type: null,
            color: null,
            msg: null,
            show: false,
            data: null,
            timeout: 0,
            dismissible: false,
            showWarn: false
        },
        to: null,
        from: null,
        searchText: null,
        search: null,
        loading: false,
        hospItems: null,
        err: false,
        file: null,
        screen_width: document.documentElement.clientWidth + 9,
        headers: [{ text: 'APPROVAL NO.', value: 'OPAN_N' }, { text: 'NAME', value: 'LAST_M' }, { text: 'HMI ID', value: 'MEMB_N' }, { text: 'APPROVAL DATE', value: 'APPR_D' }, { text: 'VALID UNTIL', value: 'VALI_D' }, { text: 'ISSUER', value: 'ISSU_N' }, { text: 'ACTION' }]
    }),
    computed: {
        ...mapGetters(['generateReportData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        async generateReportData(newVal) {
            this.loadingGenBtn = false
            if (newVal) {
                if (newVal.status === 406) {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 2000
                    this.notif.dismissible = true
                    this.notif.msg = newVal.state
                } else if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.dismissible = true
                    this.showDialog = false
                    this.notif.showWarn = newVal.data.warn !== null
                    this.notif.msg = `A new ledger has been created with control no.: ${newVal.data.control_number}, row count: ${newVal.data.number_of_rows}`
                    this.getLedgerControls({ MSU_C: this.hosp.hosp_msu_code })
                }
                this.notif.show = true
                this.notif.data = newVal.data
                this.$emit('generateNotif', this.notif)
            }
        }
    },
    mounted(){
        this.to = moment().format('YYYY-MM-DD')
        this.from = moment(this.to).subtract(3, 'days').format('YYYY-MM-DD')
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['generateReport', 'getLedgerControls']),
        genReport() {
            this.loadingGenBtn = true
            this.generateReport({ FR_D: this.from, TO_D: this.to, MSU_C: this.hosp.hosp_msu_code })
        },
        formatDate(date) {
            return moment(date).format('MMM DD, YYYY')
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>
